import React from 'react';

import { string, shape, oneOf } from 'prop-types';

import { NotificationContainer } from 'react-notifications';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';

import 'react-notifications/lib/notifications.css';
import './Notification.scss';

const validPosition = (propValue, propName, componentName) => {
  const positions = ['bottom', 'center', 'top', 'right', 'left'];
  const positionValue = propValue[propName];
  let error;
  positionValue.split(' ').forEach(element => {
    if (positions.indexOf(element) === -1) {
      error = new Error(
        `Invalid prop '${propName}' passed to '${componentName}'. Expected a valid permutation of position.`
      );
    }
  });
  return error;
};

/**
 * @deprecated
 */
export default class Notification extends BaseComponent {
  render() {
    const { transition, position, style, id, className } = this.props;

    const classes = ['Notification', className, transition, position, position];

    const classNames = ClassNames(classes);

    return (
      <div className={classNames} id={id} style={style}>
        <NotificationContainer />
      </div>
    );
  }
}

Notification.propTypes = {
  transition: oneOf(['grow', 'fade', 'slide']),
  position: validPosition,
  style: shape({}),
  id: string,
  className: string
};

Notification.defaultProps = {
  transition: 'fade',
  position: 'bottom left',
  style: {},
  id: undefined,
  className: undefined
};
